import server from "../apis/server";

const request = (method: string, endpoint: string, params: object, headers: object) => {
  switch (method) {
    case "get":
      return server.get(endpoint, { params, headers });
    case "post":
      return server.post(endpoint, params, { headers });
    case "delete":
      return server.delete(endpoint, { params, headers });
    case "put":
      return server.put(endpoint, params, { headers });
    case "patch":
      return server.patch(endpoint, params, { headers });
    default:
      // TODO: Error for unsupported method
      break;
  }
};

export default async (
  method: string,
  endpoint: string,
  onSuccess: Function,
  dispatch: Function,
  params: object = {},
  headers: object = {},
) => {
  const response = await request(method, endpoint, params, headers);
  if (response === undefined) {
    // TODO, handle server down
  } else {
    const { success, data, error, status } = response.data;
    if (success) onSuccess(data);
    else
      switch (status) {
        case 401:
          localStorage.removeItem("token");
          localStorage.removeItem("path");
          // TODO Display proper error?
          // dispatch(changePath(ROOT_PATH));
          break;
        case 400:
          // TODO, notify user of validation -> error
          console.log(error);
          alert(error);
          break;
      }
  }
};
